import React from 'react';
import { useNavigate } from 'react-router-dom';
import Ornament from './components/Ornament';
import Icon from './components/Icon';
import './Refer.css';

const Refer = () => {
    const navigate = useNavigate();

    return (
        <div className="refer-page">

            <section className="refer-hero sw-aurora">
                <div className="refer-hero-inner">
                    <Ornament variant="rule" tone="gold" size={140} />
                    <span className="refer-eyebrow">Refer · Vouch · Mediate</span>
                    <h1>Refer a job. Vouch for a candidate.</h1>
                    <p className="refer-lead">
                        Senior or junior — anyone with a credible voice can act as a Referee on
                        Samudyoga. Vouch for a candidate's competence or for the integrity of an
                        opportunity. Charge a nominal fee, or do it gratis. Stay in the middle
                        ground if you'd like, talking to both sides.
                    </p>
                    <div className="refer-cta-row">
                        <span className="refer-status-pill">
                            <Icon name="sparkle" size={14} /> Coming soon
                        </span>
                    </div>
                </div>
            </section>

            <section className="refer-section">
                <div className="sw-section-mark">How a Referee works</div>
                <div className="refer-grid">
                    <div className="refer-card">
                        <div className="refer-card-icon">1</div>
                        <h3>Vouch</h3>
                        <p>
                            Endorse a candidate's track record, or a job's credibility. Your
                            statement appears on their public profile.
                        </p>
                    </div>
                    <div className="refer-card">
                        <div className="refer-card-icon">2</div>
                        <h3>Mediate</h3>
                        <p>
                            Optionally talk to both sides — bring the right candidate to the right
                            opportunity. Stay neutral, stay senior.
                        </p>
                    </div>
                    <div className="refer-card">
                        <div className="refer-card-icon">3</div>
                        <h3>Introduce</h3>
                        <p>
                            When both sides agree, contact details are exchanged through your
                            introduction — never broadcast publicly.
                        </p>
                    </div>
                    <div className="refer-card">
                        <div className="refer-card-icon">4</div>
                        <h3>Compensate (or not)</h3>
                        <p>
                            Charge a nominal fee — say, US $300 — or refer pro bono. The
                            platform retains 10% on paid introductions for upkeep.
                        </p>
                    </div>
                </div>
            </section>

            <section className="refer-section">
                <div className="sw-section-mark">What's coming</div>
                <div className="refer-roadmap">
                    <ul>
                        <li><Icon name="check" size={16} /> A Referee dashboard in your account</li>
                        <li><Icon name="check" size={16} /> Vouch widget on candidate &amp; job profiles</li>
                        <li><Icon name="check" size={16} /> Privacy-respecting contact disclosure (only via your introduction)</li>
                        <li><Icon name="check" size={16} /> Photos shown only with the candidate's consent</li>
                        <li><Icon name="check" size={16} /> Stripe / PayPal flow for fee + 10% platform commission</li>
                    </ul>
                    <p className="sw-text-muted">
                        Until the Referee dashboard is live, you can still help informally — invite
                        candidates and partners directly to the platform.
                    </p>
                    <div style={{ marginTop: 18 }}>
                        <button className="sw-btn sw-btn-saffron" onClick={() => navigate('/contact-us')}>
                            <span>Tell us you want to be a Referee</span>
                            <Icon name="arrow" size={14} />
                        </button>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Refer;
